import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
    {
        id: "po-07-h6v1-01",
        name: "PO 01 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 47, y: 228, width: 290, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 414, width: 290, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 228, width: 265, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 703, y: 228, width: 278, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 703, y: 414, width: 278, height: 178, rotation: 0, imageRotation: 0 },
            { id: "6", x: 989, y: 228, width: 277, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 989, y: 414, width: 277, height: 178, rotation: 0, imageRotation: 0 }
            
        ],
    },

    {
        id: "po-07-h6v1-02",
        name: "PO 02 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 50, y: 154, width: 554, height: 335, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 50, y: 496, width: 273, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 331, y: 496, width: 273, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 704, y: 154, width: 230, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 704, y: 327, width: 230, height: 165, rotation: 0, imageRotation: 0 },
            { id: "6", x: 704, y: 500, width: 230, height: 165, rotation: 0, imageRotation: 0 },
            { id: "7", x: 942, y: 154, width: 318, height: 511, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-03",
        name: "PO 03 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 53, y: 173, width: 554, height: 340, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 521, width: 180, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 241, y: 521, width: 179, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 428, y: 521, width: 179, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 703, y: 126, width: 554, height: 328, rotation: 0, imageRotation: 0 },
            { id: "6", x: 703, y: 462, width: 373, height: 232, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1084, y: 462, width: 173, height: 232, rotation: 0, imageRotation: 0 }  
        ],
    },

    {
        id: "po-07-h6v1-04",
        name: "PO 04 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 48, y: 119, width: 277, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 119, width: 276, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 316, width: 277, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 333, y: 316, width: 276, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 48, y: 513, width: 277, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 333, y: 513, width: 276, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 771, y: 119, width: 424, height: 582, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-05",
        name: "PO 05 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 62, y: 212, width: 291, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 361, y: 212, width: 291, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 212, width: 291, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 62, y: 415, width: 291, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 361, y: 415, width: 291, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 415, width: 291, height: 194, rotation: 0, imageRotation: 0 },
            { id: "7", x: 660, y: 212, width: 291, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-06",
        name: "PO 06 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 101, y: 108, width: 449, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 101, y: 415, width: 449, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 557, y: 108, width: 415, height: 606, rotation: 0, imageRotation: 0 },
            { id: "4", x: 980, y: 108, width: 231, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 980, y: 262, width: 231, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 416, width: 231, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 980, y: 569, width: 231, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-07",
        name: "PO 07 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 48, y: 126, width: 284, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 319, width: 284, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 512, width: 284, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 340, y: 126, width: 370, height: 570, rotation: 0, imageRotation: 0 },
            { id: "5", x: 718, y: 126, width: 543, height: 371, rotation: 0, imageRotation: 0 },        
            { id: "6", x: 718, y: 505, width: 268, height: 191, rotation: 0, imageRotation: 0 },
            { id: "7", x: 994, y: 505, width: 268, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-08",
        name: "PO 08 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 71, y: 159, width: 354, height: 502, rotation: 0, imageRotation: 0 },
            { id: "2", x: 434, y: 159, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 434, y: 329, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 434, y: 499, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 706, y: 499, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 499, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "7", x: 706, y: 159, width: 535, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-09",
        name: "PO 09 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 72, y: 159, width: 354, height: 502, rotation: 0, imageRotation: 0 },
            { id: "2", x: 434, y: 499, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 499, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 159, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 329, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 499, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "7", x: 434, y: 159, width: 536, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-10",
        name: "PO 10 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 71, y: 159, width: 536, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 498, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 498, width: 264, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 616, y: 159, width: 353, height: 502, rotation: 0, imageRotation: 0 },
            { id: "5", x: 977, y: 159, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 977, y: 329, width: 263, height: 162, rotation: 0, imageRotation: 0 },
            { id: "7", x: 977, y: 499, width: 263, height: 162, rotation: 0, imageRotation: 0 }
        ],
    }
];